import { IWPImage, IWPLink } from "@/src/types";
import { graphql, useStaticQuery } from "gatsby";

export type IFooterData = {
  wp: {
    siteSettings: {
      siteSettings: {
        footer: {
          logo: IWPImage;
          contactColumn: {
            address: string;
            email: string;
            imagePhone: string;
            phone: string;
            title: string;
          };
          infoContent: {
            infoText: {
              text: string;
            }[];
          };
          legal: {
            links: {
              link: IWPLink;
            }[];
          };
          linksColumn: {
            footerLinks: {
              link: IWPLink;
            }[];
            title: string;
          };
          socialMediaColumn: {
            socialMediaLinks: {
              icon: string;
              link: IWPLink;
            }[];
            title: string;
          };
        };
      };
    };
  };
};

const useFooterData = () => {
  const { wp }: IFooterData = useStaticQuery(graphql`
    {
      wp {
        siteSettings {
          siteSettings {
            footer {
              contactColumn {
                address
                email
                imagePhone
                phone
                title
              }
              infoContent {
                infoText {
                  text
                }
              }
              legal {
                links {
                  link {
                    target
                    title
                    url
                  }
                }
              }
              linksColumn {
                footerLinks {
                  link {
                    target
                    title
                    url
                  }
                }
                title
              }
              socialMediaColumn {
                socialMediaLinks {
                  icon
                  link {
                    target
                    title
                    url
                  }
                }
                title
              }
              logo {
                localFile {
                  childImageSharp {
                    gatsbyImageData(placeholder: BLURRED)
                  }
                }
                altText
              }
            }
          }
        }
      }
    }
  `);
  return wp.siteSettings.siteSettings.footer;
};
export default useFooterData;
